import { render, staticRenderFns } from "./BaseSelectWithOptions.vue?vue&type=template&id=48a64bb3"
import script from "./BaseSelectWithOptions.vue?vue&type=script&lang=js"
export * from "./BaseSelectWithOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports